import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_SELECT_REQUESTED: 'CREATE_OR_UPDATE_SELECT_REQUESTED',
    CREATE_OR_UPDATE_SELECT_SUCCEEDED: 'CREATE_OR_UPDATE_SELECT_SUCCEEDED',
    CREATE_OR_UPDATE_SELECT_FAILED: 'CREATE_OR_UPDATE_SELECT_FAILED',

    addOrUpdateSelect: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_SELECT_REQUESTED,
            payload: data
        }},

    createOrUpdateSelect: async (data = undefined) => {
        let url = `selects/create`;
        let bodyFormData = new FormData();

        if (data.title) bodyFormData.set('title', data.title );
        if (data.title_ar) bodyFormData.set('title_ar', data.title_ar );
        if (data.placeholder) bodyFormData.set('placeholder', data.placeholder);
        if (data.placeholder_ar) bodyFormData.set('placeholder_ar', data.placeholder_ar);
        if (data.item_ids) bodyFormData.set('item_ids', JSON.stringify(data.item_ids));
        if (data.brand_path) bodyFormData.set('brand_path', data.brand_path);
        if (data.category_path) bodyFormData.set('category_path', data.category_path);

        bodyFormData.set('is_active', data.is_active ? true : false);

        if (data.image) bodyFormData.append('image', data.image );
        if (data.image_ar) bodyFormData.append('image_ar', data.image_ar);

        if(data._id) {
            url = `selects/` + data._id
            try {
                const select = await axiosInstance.put(url, bodyFormData);
                return select.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const select = await axiosInstance.post(url, bodyFormData);
                return select.data;
            } catch (error) {
                throw error;
            }
        }
    }
};

export default actions;
